import Swiper from 'swiper';

const moduleName = 'advantages';

export function advantages() {

    Array.from(document.querySelectorAll('.js-advantages')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const advantages = self;
        const SWIPER_BREAKPOINT = 1024;
        const advantagesButtons = advantages.querySelectorAll('.js-advantages-button');
        const advantagesSlider = advantages.querySelector('.js-advantages-slider');
        const advantagesSliderWrapper = advantages.querySelector('.js-advantages-slider-wrapper');
        const advantagesItems = advantages.querySelectorAll('.js-advantages-item');
        const advantagesPrevButton = advantages.querySelector('.js-advantages-prev-button');
        const advantagesNextButton = advantages.querySelector('.js-advantages-next-button');
        const advantagesSwiperOptions = {
            loop: true,
            simulateTouch: false,
            slideActiveClass: '_active',
            autoHeight: true,
            navigation: {
                prevEl: advantagesPrevButton,
                nextEl: advantagesNextButton
            }
        };
        let advantagesSwiper;
        let advantagesActiveItemIndex;

        initAdvantagesSwiper();

        Array.from(advantagesButtons).forEach((advantagesButton) => {
            advantagesButton.addEventListener('click', () => {
                if (advantagesButton.classList.contains('_active') || document.body.clientWidth < SWIPER_BREAKPOINT) return;

                const activeAdvantagesItem = advantages.querySelector('.js-advantages-item._active');
                const advantagesItem = advantagesButton.closest('.js-advantages-item');

                activeAdvantagesItem.classList.remove('_active');
                advantagesItem.classList.add('_active');
            });
        });

        window.addEventListener('resize', initAdvantagesSwiper);



        function initAdvantagesSwiper() {
            if (document.body.clientWidth < SWIPER_BREAKPOINT && typeof advantagesSwiper != 'object') {
                advantagesSlider.classList.add('swiper-container');
                advantagesSliderWrapper.classList.add('swiper-wrapper');
                Array.from(advantagesItems).forEach((advantagesItem) => advantagesItem.classList.add('swiper-slide'));
                advantagesSwiperOptions.initialSlide = getAdvantagesActiveItemIndex();

                advantagesSwiper = new Swiper(advantagesSlider, advantagesSwiperOptions);
            } else if (document.body.clientWidth >= SWIPER_BREAKPOINT && typeof advantagesSwiper == 'object') {
                advantagesActiveItemIndex = getAdvantagesActiveItemIndex();

                advantagesSwiper.destroy();
                advantagesSlider.classList.remove('swiper-container');
                advantagesSliderWrapper.classList.remove('swiper-wrapper');

                Array.from(advantagesItems).forEach((advantagesItem, index) => {
                    advantagesItem.classList.remove('swiper-slide');
                    if (index == advantagesActiveItemIndex) advantagesItem.classList.add('_active');
                });

                advantagesSwiper = undefined;
            }
        }

        function getAdvantagesActiveItemIndex() {
            const advantagesActiveItem = advantages.querySelector('.js-advantages-item._active');

            if (advantagesActiveItem) {
                return Array.from(advantagesItems).indexOf(advantagesActiveItem);
            } else {
                return 0;
            }
        }
    });

}